"use strict";
var ɵngcc0 = require('@angular/core');
var ɵngcc1 = require('@angular/common/http');
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var http_1 = require("@angular/common/http");
var operators_1 = require("rxjs/operators");
var deliverables_shared_service_1 = require("../deliverables-shared.service");
var deliverable_client_config_1 = require("../../deliverable.client.config");
var helpers_1 = require("../../helpers");
var i0 = require("@angular/core");
var i1 = require("@angular/common/http");
var i2 = require("../../deliverable.client.config");
var MasterProjectsService = /** @class */ (function () {
    /**
     * Initialises a new instance of the ProductionService /> class.
     * @param http
     * @param config
     */
    function MasterProjectsService(http, 
    //private authService: BfAuthService,
    config) {
        this.http = http;
        this.config = config;
    }
    /**
   * Gets a full production project
   * @param id
   * @returns An Observable containing the VideoProject
   */
    MasterProjectsService.prototype.GetFullProject = function (projectId) {
        return this.http.get(this.config.DeliverablesApiURL + "/api/masterprojects/" + projectId + "/full")
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
   * Gets a production project head
   * @param id
   * @returns An Observable containing the VideoProject
   */
    MasterProjectsService.prototype.GetHeadProject = function (projectId) {
        return this.http.get(this.config.DeliverablesApiURL + "/api/masterprojects/" + projectId + "/head")
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
   * List Tasks By search parameters
   * @param listPhasesRequest
   * @returns An Observable containing the IDeliverableAggregatePagedList<Video>
   */
    MasterProjectsService.prototype.ListTasks = function (page, pageSize, feedId, statuses, ownerIds, spaceTypes, fromDate, toDate, orderByCriteria, campaignIds, contentTypeIds, tagIds, sowIds, teamIds) {
        if (page === void 0) { page = 1; }
        if (pageSize === void 0) { pageSize = 10; }
        var params = new http_1.HttpParams();
        params = params.set('page', page.toString());
        params = params.set('pageSize', pageSize.toString());
        // feed criteria
        if (feedId) {
            params = params.set('feedId', feedId.toString());
        }
        if (statuses)
            params = params.set('statuses', statuses.toString());
        // owner id criteria
        if (ownerIds)
            params = params.set('ownerIds', ownerIds);
        if (spaceTypes)
            params = params.set('spaceTypes', spaceTypes.toString());
        if (fromDate)
            // convert to unix epoch time and string
            params = params.set('fromDate', fromDate.valueOf().toString());
        if (toDate)
            // convert to unix epoch time and string
            params = params.set('toDate', toDate.valueOf().toString());
        // campaign filter
        if (campaignIds)
            params = params.set('campaignIds', campaignIds);
        // content type filter
        if (contentTypeIds)
            params = params.set('contentTypeIds', contentTypeIds);
        // tagid filter
        if (tagIds)
            params = params.set('tagIds', tagIds);
        // SOW filter
        if (sowIds)
            params = params.set('sowIds', sowIds);
        // Teams filter
        if (teamIds)
            params = params.set('teamIds', teamIds);
        // sort order
        if (orderByCriteria)
            params = params.set('orderByCriteria', orderByCriteria);
        return this.http.get(this.config.DeliverablesApiURL + "/api/masterprojects/tasks", { params: params })
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * List  By search parameters
     * @param listRequest
     * @returns An Observable containing the IDeliverablePagedList<Deliverable>
     */
    MasterProjectsService.prototype.ListProjects = function (page, pageSize, feedId, statuses, ownerIds, fromDate, toDate, orderByCriteria, campaignIds, contentTypeIds, tagIds, sowIds, teamIds, loadDeep) {
        if (page === void 0) { page = 1; }
        if (pageSize === void 0) { pageSize = 10; }
        var params = new http_1.HttpParams();
        params = params.set('page', page.toString());
        params = params.set('pageSize', pageSize.toString());
        // feed criteria
        if (feedId) {
            params = params.set('feedId', feedId.toString());
        }
        if (statuses)
            params = params.set('statuses', statuses.toString());
        // owner id criteria
        if (ownerIds)
            params = params.set('ownerIds', ownerIds);
        if (fromDate)
            // convert to unix epoch time and string
            params = params.set('fromDate', fromDate.valueOf().toString());
        if (toDate)
            // convert to unix epoch time and string
            params = params.set('toDate', toDate.valueOf().toString());
        // campaign filter
        if (campaignIds)
            params = params.set('campaignIds', campaignIds);
        // content type filter
        if (contentTypeIds)
            params = params.set('contentTypeIds', contentTypeIds);
        // tagid filter
        if (tagIds)
            params = params.set('tagIds', tagIds);
        // SOW filter
        if (sowIds)
            params = params.set('sowIds', sowIds);
        // Teams filter
        if (teamIds)
            params = params.set('teamIds', teamIds);
        // deep load or not
        if (loadDeep === true) {
            params = params.set('descendantLoadMode', 'AnyDescendant');
        }
        if (loadDeep === false) {
            params = params.set('descendantLoadMode', 'ImmediateChildren');
        }
        // sort order
        if (orderByCriteria)
            params = params.set('orderByCriteria', orderByCriteria);
        return this.http.get(this.config.DeliverablesApiURL + "/api/masterprojects/heads", { params: params })
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * List spaces
     * @param page
     * @param pageSize
     * @param statuses
     * @param ownerId
     * @param fromDate
     * @param toDate
     * @param orderByCriteria
     */
    MasterProjectsService.prototype.listSpaces = function (page, pageSize, feedId, statuses, ownerIds, spaceTypes, fromDate, toDate, fromDueDate, toDueDate, orderByCriteria, campaignIds, contentTypeIds, tagIds, sowIds, teamIds, loadDeep, mustBeInMaster, taskStatuses, taskOwnerIds, taskTeamIds) {
        if (page === void 0) { page = 1; }
        if (pageSize === void 0) { pageSize = 10; }
        var params = new http_1.HttpParams();
        params = params.set('page', page.toString());
        params = params.set('pageSize', pageSize.toString());
        // feed criteria
        if (feedId) {
            params = params.set('feedId', feedId.toString());
        }
        if (statuses)
            params = params.set('statuses', statuses.toString());
        // owner id criteria
        if (ownerIds)
            params = params.set('ownerIds', ownerIds);
        if (spaceTypes)
            params = params.set('spaceTypes', spaceTypes.toString());
        if (fromDate)
            // convert to unix epoch time and string
            params = params.set('fromDate', fromDate.valueOf().toString());
        if (toDate)
            // convert to unix epoch time and string
            params = params.set('toDate', toDate.valueOf().toString());
        if (fromDueDate)
            // convert to unix epoch time and string
            params = params.set('fromDueDate', fromDueDate.valueOf().toString());
        if (toDueDate)
            // convert to unix epoch time and string
            params = params.set('toDueDate', toDueDate.valueOf().toString());
        // campaign filter
        if (campaignIds)
            params = params.set('campaignIds', campaignIds);
        // content type filter
        if (contentTypeIds)
            params = params.set('contentTypeIds', contentTypeIds);
        // tagid filter
        if (tagIds)
            params = params.set('tagIds', tagIds);
        // SOW filter
        if (sowIds)
            params = params.set('sowIds', sowIds);
        // Teams filter
        if (teamIds)
            params = params.set('teamIds', teamIds);
        // deep load or not
        if (loadDeep === true) {
            params = params.set('descendantLoadMode', 'AnyDescendant');
        }
        if (loadDeep === false) {
            params = params.set('descendantLoadMode', 'ImmediateChildren');
        }
        // sort order
        if (orderByCriteria)
            params = params.set('orderByCriteria', orderByCriteria);
        // filter on in master or not
        if (mustBeInMaster !== undefined)
            params = params.set('mustBeInMaster', mustBeInMaster.toString());
        // filter by status of some child tasks
        if (taskStatuses)
            params = params.set('taskStatuses', taskStatuses.toString());
        // filter by ownership of some child tasks
        if (taskOwnerIds)
            params = params.set('taskOwnerIds', taskOwnerIds.toString());
        // filter by team ownnership of some child tasks
        if (taskTeamIds)
            params = params.set('taskTeamIds', taskTeamIds.toString());
        return this.http.get(this.config.DeliverablesApiURL + "/api/masterprojects/spaces", { params: params })
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * List stages
     * @param page
     * @param pageSize
     * @param statuses
     * @param ownerId
     * @param fromDate
     * @param toDate
     * @param orderByCriteria
     */
    MasterProjectsService.prototype.listStages = function (page, pageSize, feedId, statuses, ownerIds, spaceTypes, fromDate, toDate, orderByCriteria, campaignIds, contentTypeIds, tagIds, sowIds, teamIds, loadDeep) {
        if (page === void 0) { page = 1; }
        if (pageSize === void 0) { pageSize = 10; }
        var params = new http_1.HttpParams();
        params = params.set('page', page.toString());
        params = params.set('pageSize', pageSize.toString());
        // feed criteria
        if (feedId) {
            params = params.set('feedId', feedId.toString());
        }
        if (statuses)
            params = params.set('statuses', statuses.toString());
        // owner id criteria
        if (ownerIds)
            params = params.set('ownerIds', ownerIds);
        if (spaceTypes)
            params = params.set('spaceTypes', spaceTypes.toString());
        if (fromDate)
            // convert to unix epoch time and string
            params = params.set('fromDate', fromDate.valueOf().toString());
        if (toDate)
            // convert to unix epoch time and string
            params = params.set('toDate', toDate.valueOf().toString());
        // campaign filter
        if (campaignIds)
            params = params.set('campaignIds', campaignIds);
        // content type filter
        if (contentTypeIds)
            params = params.set('contentTypeIds', contentTypeIds);
        // tagid filter
        if (tagIds)
            params = params.set('tagIds', tagIds);
        // SOW filter
        if (sowIds)
            params = params.set('sowIds', sowIds);
        // Teams filter
        if (teamIds)
            params = params.set('teamIds', teamIds);
        // deep load or not
        if (loadDeep === true) {
            params = params.set('descendantLoadMode', 'AnyDescendant');
        }
        if (loadDeep === false) {
            params = params.set('descendantLoadMode', 'ImmediateChildren');
        }
        // sort order
        if (orderByCriteria)
            params = params.set('orderByCriteria', orderByCriteria);
        return this.http.get(this.config.DeliverablesApiURL + "/api/masterprojects/stages", { params: params })
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    MasterProjectsService.ngInjectableDef = i0.defineInjectable({ factory: function MasterProjectsService_Factory() { return new MasterProjectsService(i0.inject(i1.HttpClient), i0.inject(i2.DELIVERABLE_CLIENT_CONFIG)); }, token: MasterProjectsService, providedIn: "root" });
    MasterProjectsService = __decorate([ __param(1, core_1.Inject(deliverable_client_config_1.DELIVERABLE_CLIENT_CONFIG)),
        __metadata("design:paramtypes", [http_1.HttpClient, Object])
    ], MasterProjectsService);
MasterProjectsService.ɵfac = function MasterProjectsService_Factory(t) { return new (t || MasterProjectsService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(deliverable_client_config_1.DELIVERABLE_CLIENT_CONFIG)); };
MasterProjectsService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: MasterProjectsService, factory: function (t) { return MasterProjectsService.ɵfac(t); }, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MasterProjectsService, [{
        type: core_1.Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: Object, decorators: [{
                type: core_1.Inject,
                args: [deliverable_client_config_1.DELIVERABLE_CLIENT_CONFIG]
            }] }]; }, null); })();
    return MasterProjectsService;
}());
exports.MasterProjectsService = MasterProjectsService;

